// © 2026 Camp Promethean, LLC. All Rights Reserved.
// The Camp Promethean logo mark, sized for inline use (Promethean Plus affordances).
// Renders the light-surface mark by default and the dark-chrome mark in dark mode.
import { getBrandAssets } from "@/lib/brandAssets";
import { cn } from "@/lib/utils";

type PrometheanMarkProps = {
  className?: string;
  title?: string;
  /** Force a mark for a known surface instead of following app theme. */
  surface?: "light" | "dark";
};

export function PrometheanMark({ className, title, surface }: PrometheanMarkProps) {
  const brand = getBrandAssets("classic");

  if (surface === "light") {
    return (
      <img
        src={brand.logoMarkLight}
        alt={title ?? "Camp Promethean"}
        className={cn("object-contain", className)}
      />
    );
  }

  if (surface === "dark") {
    return (
      <img
        src={brand.logoMark}
        alt={title ?? "Camp Promethean"}
        className={cn("object-contain", className)}
      />
    );
  }

  return (
    <>
      <img
        src={brand.logoMarkLight}
        alt={title ?? "Camp Promethean"}
        className={cn("object-contain dark:hidden", className)}
      />
      <img
        src={brand.logoMark}
        alt=""
        aria-hidden="true"
        className={cn("hidden object-contain dark:block", className)}
      />
    </>
  );
}
